import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  namespaced: true,
  state: () => ({
    flow: {},
    app: {},
    codeInEditor: {},
    selectedCodeInEditor: {},
    blocklyXml: '',
    editorMode: '',
    isCurrentFlowVersionOutdated: false,
    isCurrentUserAllowedToEditFlow: true,
    isFlowEditingDisabled: false,
    variables: [],
    fieldsInCode: [],
    flowsInCode: [],
    childComponentsValidation: {
      flowTriggers: {}
    },
    lastEditedBy: ''
  }),
  getters: getters,
  mutations: mutations,
  actions: actions
}
